import * as React from 'react';
import { PopoverContext } from '../../popoverContext';
/**
 * Render the final JSX of Popover
 */ export const renderPopover_unstable = (state)=>{
    const { appearance, arrowRef, contentRef, inline, mountNode, open, openOnContext, openOnHover, setOpen, size, toggleOpen, trapFocus, triggerRef, withArrow, inertTrapFocus } = state;
    return /*#__PURE__*/ React.createElement(PopoverContext.Provider, {
        value: {
            appearance,
            arrowRef,
            contentRef,
            inline,
            mountNode,
            open,
            openOnContext,
            openOnHover,
            setOpen,
            toggleOpen,
            triggerRef,
            size,
            trapFocus,
            inertTrapFocus,
            withArrow
        }
    }, state.popoverTrigger, state.open && state.popoverSurface);
};
